












































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountLendingTermSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/Term/AccountLendingTermSettings';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountLendingTermSettingsRead' })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true })
    settings: AccountLendingTermSettings;

    PermissionUtils = PermissionUtils;

    async deleteDepositFixedTermSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositFixedTermSettings();
        }
    }

}
